import { render, staticRenderFns } from "./TarefaPrioridadeForm.vue?vue&type=template&id=3f3be502&"
import script from "./TarefaPrioridadeForm.vue?vue&type=script&lang=js&"
export * from "./TarefaPrioridadeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports